// Bileli · modules/orgs/model — the ACTIVE workspace, shared (zustand VANILLA + Teact adapter, same
// pattern as modules/live/model/myLive.store). why: the teach dashboard's workspace picker and the app
// header's role-gated nav must agree on ONE org — before this, TeachList kept the selection in local
// state while the header/pages each re-derived `pickDefaultOrg`, so per-role tabs were impossible.
// TeachList (via useMyCourses) WRITES the resolved org here; BileliAppHeader READS it for gating.

import type { BileliOrg } from './orgs.types';

import { createStore } from '../../../shared/lib/zustandTeact';
import { pickDefaultOrg } from './orgs.api';

export interface ActiveOrgState {
  /** The resolved active workspace — undefined until the teach dashboard first resolves it. */
  org?: BileliOrg;
}

export const activeOrgStore = createStore<ActiveOrgState>(() => ({ org: undefined }));

export function setActiveOrgShared(org: BileliOrg | null | undefined): void {
  const current = activeOrgStore.getState().org;
  if (org && current !== org) activeOrgStore.setState({ org });
}

/**
 * The org the MANAGEMENT pages (Команда: settings/members/rename) should target: the ACTIVE
 * workspace when known — matched back into the freshly fetched list so the row carries the current
 * `role`/name — else the personal-first default. Before this, those pages always managed the
 * personal org regardless of the picked workspace, which made institutional rename unreachable.
 */
export function resolveManagedOrg(orgs: BileliOrg[]): BileliOrg | null {
  const active = activeOrgStore.getState().org;
  return (active && orgs.find((o) => o.id === active.id)) ?? pickDefaultOrg(orgs);
}
